// Drop Down Action

import {
  TIMER_DROP_DOWN,
  TIMER_DROP_DOWN_SUCCESS,
  TIMER_DROP_DOWN_FAILURE,
} from "./actionType";

export const timerDropDown = (payload) => {
  return {
    type: TIMER_DROP_DOWN,
    payload,
  };
};

export const timerDropDownSuccess = (payload) => {
  return {
    type: TIMER_DROP_DOWN_SUCCESS,
    payload,
  };
};

export const timerDropDownFailure = (payload) => {
  return {
    type: TIMER_DROP_DOWN_FAILURE,
    payload,
  };
};
